import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import DotsComponent from '../shared/DotsComponent'
import LogoDecor from '../shared/LogoComponent';
const Layout = styled.div`
    margin-top:10rem;
    display:grid;
    grid-auto-flow:row;
    grid-gap:1.5rem;
    width:100%;
    justify-content:center;
    
    padding: 5rem 0rem 11rem;
    .header{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-40);
        line-height: var(--space-44);

        color: #353B40;
    }
    .text{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-20);

        color: #353B40;
    }

    @media (max-width: 500px){
        margin-top: 3rem;
        .header{
            justify-self: center;
            font-size: var(--font-24);
        }
        .text{
            width: inherit;
            justify-self: center;
            font-size: var(--font-16);
        }

    }
`;
const ForgotForm = styled.form`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:space-between;
    width:100%;
    .input{
        width: 75%;
        padding: var(--space-18) var(--space-24);
        height: 3.25rem;
        text-indent:1rem;

        background: #F6F8F8;

        border: 1px solid #D3D9DE;
        box-sizing: border-box;
        border-radius: 8px;
    }
    .button{
        padding: var(--space-18) var(--space-40);
        color:var(--color-white);
        height: 3.125rem;

        background: #09CCBA;
        box-shadow: 0px 2px 6px rgba(16, 216, 197, 0.16), 0px 6px 15px rgba(16, 216, 197, 0.34);
        border-radius: 44px;
    }
  
    .side-curves{
        position:absolute;
        bottom:6rem;
        left:52rem;
        width:30rem;
    }
    .top-curves{
        position:absolute;
        bottom:15rem;
        right:20rem;
        width:40rem;
    }

    @media (max-width: 500px){
        .input{
            width: 100%;
        }
        width: inherit;
        height: 8rem;
        flex-direction: column;
        margin-bottom: 3rem;
    }
`;
const Forgot = () => {
    return (
        <>
            <LogoDecor />
            <Layout>
                {/* <DotsComponent/> */}
                <h1 className="header">Forgot your Password?</h1>
                <p className="text">Enter the email you signed up with and we will send you reset instructions.</p>
                <ForgotForm>

                    <input className="input" type="email" placeholder="Email" />
                    <button className="button">Submit</button>
                    <img className="side-curves" src="/img/side_curves.svg" alt="side curves" />
                    <img className="top-curves" src="/img/top_curves.svg" alt="top curves" />
                </ForgotForm>
            </Layout>
        </>
    )
}

export default Forgot
